/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Customer_Group_ErrorInputs */

const vi_toast_customer_group_error = /** @type {(inputs: Toast_Customer_Group_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thao tác nhóm khách hàng thất bại`)
};

/**

* @param {Toast_Customer_Group_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_customer_group_error = /** @type {((inputs?: Toast_Customer_Group_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Customer_Group_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_customer_group_error(inputs)
});